import Link from "next/link";

export default function Footer3() {
    return (
        <>

            {/* Footer area start */}
            <footer className="dark">
                {/* container */}
                <div
                    className="px-[5%] g-0 line_4 bg-cover bg-center w-full "
                // style={{ backgroundImage: "url('/assets/images/2.png')", backgroundPosition: 'right', opacity: 0.2  }}
                >
                    {/* <div className="line-col-4">
                        <div />
                        <div />
                        <div />
                        <div />
                    </div> */}

                    <div className="row">
                        <div className="col-xxl-12">
                            <div className="footer__top-6 pt-20">
                                {/* footer__item-6 */}
                                <div className="w-full lg:w-1/5 mr- lg:mr-4">
                                    <img loading="lazy" decoding="async"
                                        className="footer__logo logo-light "
                                        // src="/assets/imgs/logo/site-logo-white-2.png"
                                        // src="/assets/jbcodeapp_logo_white_with_icon_no_space.webp"
                                        src="/assets/jbcodeapp_logo_white_logo.png"
                                        alt="Footer Logo"
                                    />
                                    <img loading="lazy" decoding="async"
                                        className="footer__logo logo-dark "
                                        // src="/assets/imgs/logo/site-logo-white-2.png"
                                        // src="/assets/jbcodeapp_logo_white_with_icon_no_space.webp"
                                        src="/assets/jbcodeapp_logo_white_logo.png"

                                        alt="Footer Logo"
                                    />
                                    <p className="pb-3">
                                        Your partner in digital solutions. We craft innovative websites, applications, and digital marketing strategies to elevate your business and drive success.
                                    </p>

                                    {/* <div className="flex pt-5">
                                        <img src="/assets/images/icon/g1.png" className='px-1 py-2 h-16' alt="Team Member" />
                                        <img src="/assets/images/icon/up1.png" className='px-1 py-2 h-16' alt="Team Member" />
                                        <img src="/assets/images/icon/c1.png" className='px-1 py-2 h-16' alt="Team Member" />
                                    </div> */}
                                    {/* Ratings Logo */}
                                    {/* <li className='!min-w-full'> */}
                                    <div className=" grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 bg-zinc-200 rounded-lg">
                                        <div className=" flex flex-col items-center justify-center p-2">
                                            <a href="https://www.goodfirms.co/company/jbcodeapp" target="_blank" rel="noopener noreferrer" aria-label="Visit JBCodeApp on Goodfirms">
                                                <img loading="lazy" decoding="async"
                                                    src="/assets/images/icon/goodfirm.webp"
                                                    className='px-1 py-2 h-15'
                                                    alt="Goodfirms Rating"
                                                />
                                            </a>
                                        </div>
                                        <div className=" flex flex-col items-center justify-center p-2">
                                            <img loading="lazy" decoding="async"
                                                src="/assets/images/icon/google.webp"
                                                className='px-1 py-2 h-15'
                                                alt="Google Rating"
                                            />
                                        </div>
                                        <div className=" flex flex-col items-center justify-center p-2">
                                            <a href="https://clutch.co/profile/jbcodeapp" target="_blank" rel="noopener noreferrer" aria-label="Visit JBCodeApp on Clutch">
                                                <img loading="lazy" decoding="async"
                                                    src="/assets/images/icon/clutch.webp"
                                                    className='px-1 py-2 h-15'
                                                    alt="Clutch Rating"
                                                />
                                            </a>
                                        </div>
                                        <div className=" flex flex-col items-center justify-center p-2">
                                            <a href="https://www.upwork.com/agencies/jbcodeapp/" target="_blank" rel="noopener noreferrer" aria-label="Visit JBCodeApp on Upwork">
                                                <img loading="lazy" decoding="async"
                                                    src="/assets/images/icon/upwork.webp"
                                                    className='px-1 py-2 h-15'
                                                    alt="Upwork Rating"
                                                />
                                            </a>
                                        </div>

                                    </div>
                                    {/* </li> */}
                                    <div className="py-3">
                                        <span className="h2 footer__item-title mb-[-5%] text-white">Mail</span>
                                        <div>
                                            <a className="text-[#999] mb-3 hover:text-white hover:underline" href="mailto:contact@jbcodeapp.com">contact@jbcodeapp.com</a>
                                        </div>
                                    </div>

                                    <span className="h2 footer__item-title mb-[-5%] mt-3 text-white ">Find</span>
                                    <p className="pb-0 sm:pb-4">
                                        536-537, 5 Square Point, M.V Circle,
                                        JahangirPura, Surat, Gujarat 395005
                                    </p>

                                </div>

                                {/* Hire */}
                                <div className="w-full lg:w-1/6 mt-2 mb-2  ">
                                    <span className="h2 !pb-[0px] footer__item-title text-white">Hire Developer Team</span>
                                    <ul className="footer__link-6 !pt-[20px]">
                                        <li>
                                            <a href="/services/web/hire-laravel-web-developers/" aria-label="Hire Laravel Developers">Hire Laravel Developers</a>
                                        </li>
                                        <li>
                                            <a href="/services/web/hire-php-web-developers/" aria-label="Hire PHP Developers">Hire PHP Developers</a>
                                        </li>
                                        <li>
                                            <a href="/services/web/hire-reactjs-developers/" aria-label="Hire ReactJS Developers">Hire ReactJS Developers</a>
                                        </li>
                                        <li>
                                            <a href="/services/web/hire-nodejs-developers/" aria-label="Hire NodeJS Developers">Hire NodeJS Developers</a>
                                        </li>
                                        <li>
                                            <a href="/services/mobile/hire-android-app-developers/" aria-label="Hire Android Developers">Hire Android Developers</a>
                                        </li>
                                        <li>
                                            <a href="/services/mobile/hire-ios-developers/" aria-label="Hire iOS App Developers">Hire iOS App Developers</a>
                                        </li>
                                    </ul>
                                    <span className="footer__item-title text-white"></span>
                                    <ul className="footer__link-6 !pt-[20px]">
                                        <li>
                                            <a href="/services/hire-dedicated-developers/" aria-label="Hire Dedicated Developers">Hire Dedicated Developers</a>
                                        </li>
                                        <li>
                                            <a href="/services/hire-web-developers/" aria-label="Hire Web Developers">Hire Web Developers</a>
                                        </li>
                                        <li>
                                            <a href="/services/hire-frontend-developers/" aria-label="Hire Frontend Developers">Hire Frontend Developers</a>
                                        </li>
                                        <li>
                                            <a href="/services/hire-backend-developers/" aria-label="Hire Backend Web Developers">Hire Backend Web Developers</a>
                                        </li>
                                        <li>
                                            <a href="/services/hire-fullstack-dedicated-developers/" aria-label="Hire Fullstack Developers">Hire Fullstack Developers</a>
                                        </li>
                                        <li>
                                            <a href="/services/web/hire-wordpress-developers/" aria-label="Hire Wordpress Developers">Hire Wordpress Developers</a>
                                        </li>
                                        <li>
                                            <a href="/services/mobile/hire-ipad-game-developer/" aria-label="Hire iPad Game Developers">Hire iPad Game Developers</a>
                                        </li>
                                    </ul>
                                    {/* <hr className="text-white"/> */}
                                </div>

                                {/* Services */}
                                <div className="w-full lg:w-1/6 mt-2 mb-2  ">
                                    <span className="footer__item-title text-white">Services</span>
                                    <ul className="footer__link-6 !pt-[20px]">
                                        <li>
                                            <a href="/what-we-do/web-development/" aria-label="Web Development">Web Development</a>
                                        </li>
                                        <li>
                                            <a href="/what-we-do/mobile-app-development/" aria-label="Mobile App Development">Mobile App Development</a>
                                        </li>
                                        <li>
                                            <a href="/what-we-do/design/" aria-label="UI/UX Designs">UI/UX Designs</a>
                                        </li>
                                        <li>
                                            <a href="/what-we-do/ai-ml-solutions/" aria-label="AI & ML App Development">
                                                AI & ML App Development
                                            </a>
                                        </li>
                                        <li>
                                            <a href="/services/digital-marketing-services/" aria-label="Digital Marketing">
                                                Digital Marketing
                                            </a>
                                        </li>

                                        <li>
                                            <a href="/services/offshore-development-center/" aria-label="Offshore Development Center">
                                                Offshore Development Center
                                            </a>
                                        </li>

                                    </ul>
                                    <span className="footer__item-title text-white"></span>
                                    <ul className="footer__link-6 !pt-[20px]">
                                        <li>
                                            <a href="/services/offshore-software-development/" aria-label="Offshore Software Development">
                                                Offshore Software Development
                                            </a>
                                        </li>
                                        <li>
                                            <a href="/services/web/laravel-application-development/" aria-label="Laravel Development Company">Laravel Development Company</a>
                                        </li>
                                        <li>
                                            <a href="/services/web/php-development-services/" aria-label="PHP Development Company">PHP Development Company</a>
                                        </li>
                                        <li>
                                            <a href="/services/web/reactjs-development-services/" aria-label="ReactJS Development Company">ReactJS Development Company</a>
                                        </li>
                                        <li>
                                            <a href="/services/web/nodejs-development-company/" aria-label="NodeJS Development Company">NodeJS Development Company</a>
                                        </li>
                                        <li>
                                            <a href="/services/mobile/ios-app-development/" aria-label="iOS App Development Company">iOS App Development Company</a>
                                        </li>
                                        <li>
                                            <a href="/services/mobile/android-application-development/" aria-label="Android Development Company">Android Development Company</a>
                                        </li>
                                    </ul>
                                </div>

                                {/* Industries */}
                                <div className="w-full lg:w-1/6 mt-2 mb-2  ">
                                    <span className="footer__item-title text-white">Industries</span>
                                    <ul className="footer__link-6 !pt-[20px]">
                                        <li>
                                            <a href="/industries/education-e-learning-it-solutions/" aria-label="Education / e-learning">Education / e-learning</a>
                                        </li>
                                        <li>
                                            <a href="/industries/healthcare-it-solutions/" aria-label="Healthcare">Healthcare</a>
                                        </li>
                                        <li>
                                            <a href="/industries/logistics-and-distribution-it-solutions/" aria-label="Logistics & Distribution">Logistics & Distribution</a>
                                        </li>
                                        <li>
                                            <a href="/industries/finance-and-insurance/" aria-label="Finance & Insurance">Finance & Insurance</a>
                                        </li>
                                        <li>
                                            <a href="/industries/it-and-telecom/" aria-label="IT and Telecom Solutions">IT and Telecom Solutions</a>
                                        </li>
                                        <li>
                                            <a href="/industries/media-and-entertainment/" aria-label="Media & Entertainment">Media & Entertainment</a>
                                        </li>
                                    </ul>
                                    <span className="footer__item-title text-white"></span>
                                    <ul className="footer__link-6 !pt-[20px]">
                                        <li>
                                            <a href="/industries/social-media/" aria-label="Social Media">Social Media</a>
                                        </li>
                                        <li>
                                            <a href="/industries/sports/" aria-label="Sports">Sports</a>
                                        </li>
                                        <li>
                                            <a href="/industries/retail-it-solutions/" aria-label="Retail and eCommerce">Retail & eCommerce</a>
                                        </li>
                                        <li>
                                            <a href="/industries/real-estate-construction/" aria-label="Real Estate and Construction">Real Estate & Construction</a>
                                        </li>
                                        <li>
                                            <a href="/industries/travel-and-hospitality-it-solutions/" aria-label="Travel and Hospitalty">Travel & Hospitalty</a>
                                        </li>
                                    </ul>
                                </div>

                                {/*Company flex space-x-9 pt-5 */}
                                <div className="w-full lg:w-1/6 mt-2 mb-2  ">
                                    <span className="footer__item-title text-white">Company</span>
                                    <ul className="footer__link-6 !pt-[20px]">
                                        <li>
                                            <a href="/about/" aria-label="About Us">About Us</a>
                                        </li>
                                        <li>
                                            <a
                                                href="/how-to-engage/" aria-label="How We Work"
                                            >
                                                How We Work
                                            </a>
                                        </li>
                                        <li>
                                            <a href="/career/" aria-label="Career">Career</a>
                                        </li>
                                        <li>
                                            <a href="/methodologies/" aria-label="Methodology">
                                                Methodology
                                            </a>
                                        </li>
                                        <li>
                                            <a href="/faqs/" aria-label="Faqs">Faqs</a>
                                        </li>
                                        <li>
                                            <a href="/blog/" aria-label="Blogs">Blogs</a>
                                        </li>
                                    </ul>

                                </div>

                            </div>
                            {/* social media */}
                            <ul className="footer__social-6 flex space-x-2 text-center justify-center pb-5">
                                <li>
                                    <a href="https://www.linkedin.com/company/jbcodeapp/" className="text-gray-600 " target="_blank" rel="noopener noreferrer" aria-label="Visit JBCodeApp on LinkedIn">
                                        <span className="text-3xl">
                                            {/* text-[#0077b5] */}
                                            <i className="fa-brands fa-linkedin  hover:text-white"></i>
                                        </span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/jbcodeapp" className="text-gray-600 " target="_blank" rel="noopener noreferrer" aria-label="Visit JBCodeApp on Instagram">
                                        <span className="text-3xl">
                                            {/* text-[#e1306c] */}
                                            <i className="fa-brands fa-square-instagram  hover:text-white"></i>
                                        </span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://twitter.com/jbcodeapp" className="text-gray-600 " target="_blank" rel="noopener noreferrer" aria-label="Visit JBCodeApp on Twitter">
                                        <span className="text-3xl">
                                            {/* text-[#1da1f2] */}
                                            <i className="fa-brands fa-square-twitter  hover:text-white"></i>
                                        </span>
                                    </a>
                                </li>

                                <li>
                                    <a href="https://www.facebook.com/jbcodeapp" className="text-gray-600 " target="_blank" rel="noopener noreferrer" aria-label="Visit JBCodeApp on Facebook">
                                        <span className="text-3xl">
                                            {/* text-[#3b5998] */}
                                            <i className="fa-brands fa-square-facebook  hover:text-white"></i>
                                        </span>
                                    </a>
                                </li>

                                <li>
                                    <a href="https://www.youtube.com/@jbcodeapp" className="text-gray-600" target="_blank" rel="noopener noreferrer" aria-label="Youtube">
                                        <span className="text-3xl">
                                            {/* text-[#FF0000] */}
                                            <i className="fa-brands fa-square-youtube  hover:text-white"></i>
                                        </span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://dribbble.com/jbcodeapp" className="text-gray-600" target="_blank" rel="noopener noreferrer" aria-label="Visit JBCodeApp on Dribbble">
                                        <span className="text-3xl">
                                            {/* text-[#EA4C89] */}
                                            <i className="fa-brands fa-square-dribbble  hover:text-white"></i>
                                        </span>
                                    </a>
                                </li>
                            </ul>
                            <div className="footer__btm-6">
                                <div className="row">
                                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-5">
                                        <div className="footer__copyright-6">
                                            <p>
                                                © 2019 - {new Date().getFullYear()} | Alrights reserved by &nbsp;
                                                <a href="/" target="_blank" className="text-[#fff] !hover:text-white" aria-label="JBcodeapp">
                                                    JBcodeapp
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-7">
                                        <div className="footer__nav">
                                            <ul className="footer-menu menu-anim ">
                                                <li>
                                                    <a href="/privacy-policy/" aria-label="Privacy Policy">Privacy Policy</a>
                                                </li>
                                                <li>
                                                    <a href="/terms-conditions/" aria-label="Terms & Condition">Terms & Condition</a>
                                                </li>
                                                <li>
                                                    <a href="/faqs/" aria-label="Faq">Faq</a>
                                                </li>
                                                <li>
                                                    <a href="/sitemap/" aria-label="Sitemap">Sitemap</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            {/* Footer area end */}
        </>
    )
}